import { render, staticRenderFns } from "./RegPrasymasSutartisPreliminari.vue?vue&type=template&id=c2763708&scoped=true&"
import script from "./RegPrasymasSutartisPreliminari.vue?vue&type=script&lang=js&"
export * from "./RegPrasymasSutartisPreliminari.vue?vue&type=script&lang=js&"
import style0 from "./RegPrasymasSutartisPreliminari.vue?vue&type=style&index=0&id=c2763708&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2763708",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VFooter,VRow,VSpacer})
